import React, { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import AuthContext from "../../../../context/auth/authContext";
import Modulos from "../../../general/screen/Modulos";
import EcosistemaTitulo from "../../ecosistemas/EcosistemaTitulo";
import HomeInUser from "../../principal/components/HomeInUser";
import EmpleabilidadCards from "../components/EmpleabilidadCards";
import useTitle from "../../../hooks/useTitle";

const EmpleabilidadScreen = () => {
  useTitle({ title: "Detalle Ecosistema Empleabilidad" });
  const { pathname } = useLocation();
  const { globalActualizarEcosistemaActivo } = useContext(AuthContext);

  useEffect(() => {
    if (pathname === "/ecosistema/empleabilidad") {
      globalActualizarEcosistemaActivo(3);
    }
  }, []);

  return (
    <div className="homein">
      <EcosistemaTitulo />

      <div className="homein__resumen">
        <HomeInUser id={3} />
      </div>

      <div className="homein__detalle">
        <Modulos />
        <EmpleabilidadCards />
      </div>
    </div>
  );
};

export default EmpleabilidadScreen;
